import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'cms-skiplink',
  styleUrl: 'cms-skiplink.scss',
  shadow: { delegatesFocus: true },
})
export class CmsSkiplink {
  /**
   * set the id for the target of the skiplink
   */
  @Prop({ mutable: true }) target!: string;
  /**
   * set the label of the skiplink
   */
  @Prop({ mutable: true }) label!: string;

  render() {
    return (
      <Host>
        <cms-link
          class='link'
          type='standalone'
          content={this.label}
          href={`#${this.target}`}
        />
      </Host>
    );
  }
}
